import React, { Component } from 'react'
import ListItem from './Portfolio/ListItem'

import '../styles/PortfolioMobile.css';

import ContactUsCircle from '../../assets/Contact Us Circle.svg';
import Tape from '../../assets/Tape.svg';

export default class Portfolio extends Component {

	convertDataToJSX = (data, activeKey) => {

		let cols = [];

		let numRows = data.length / 2;
		
		let currentArrayIndex = 0;

		for (let i = 0; i < 2; i++) {
			let items = [];

			for (let k = 0; (k < numRows) && (currentArrayIndex < data.length); k++) {

				let artist = data[currentArrayIndex];
				const { key, name, picture } = artist;

				items.push(
					<ListItem inactive={(key != activeKey) && (activeKey != null)}
								image={picture}
								name={name}
								clickFunc={this.props.selectArtistAction.bind(this, key)}/>
				);

				currentArrayIndex++;

			}

			cols.push(items);
		}

		let content = [];
		cols.forEach(function (items) {
			content.push(<div className="col">
				{items}
			</div>);
		})

		return content;

	}

  render() {

		let content = null;
		if (this.props.isLoading) {
			content = <div className="loading-text">Loading...</div>;
		} else {
			content = this.convertDataToJSX(this.props.artists, this.props.selectedArtistKey);
		}

		let goBack = null;
		if (this.props.selectedArtistKey == null) {
			goBack = <div className="goback-container">
				<div className="goback-button" onClick={this.props.leftAction}>
					<img src={ContactUsCircle} className="goback-circle" />
					Go back
					</div>
			</div>;
		}

		let containerResized = '';
		if (this.props.selectedArtistKey != null) {
			containerResized = 'resized';
		} else {
			containerResized = '';
		}

    return (
		<div className={`mobile-scrollable-flex-container  ${containerResized}`} onClick={this.props.closeAction}>

				{goBack}

				<div className="mobile-tape">
					<img src={Tape} className="asset" />
				</div>

				<div className={`mobile-artists-container  ${containerResized}`}>

					{content}

				</div>


      </div>
    )
  }
}
